module.exports = __webpack_public_path__ + "img/19.89deac3f.png";